/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  Header,
  Footer,
  Loading,
  Comment2,
  Paginate,
} from '../../components/index'
import { WebApi } from '../../api/web'

const CommentsLawer = () => {
  const { id } = useParams()
  const [commentsData, setComments] = useState(null)
  const [totalPage, setTotalPage] = useState(1)
  const [page, setPage] = useState(1)

  useEffect(() => {
    Comments()
  }, [page])
  const Comments = async () => {
    await WebApi.comments(id, page)
      .then((res) => {
        setComments(res.data.data.comments.comments)
        setTotalPage(res.data.data.comments.totalPages)
      })
      .catch((err) => {})
  }

  return (
    <>
      <Header title='نظرات کاربران' />
      <div className='container'>
        <div className='template-pages'>
          {commentsData ? (
            <>
              {commentsData.map((comment) => (
                <Comment2
                  name={`${comment.writer.fname} ${comment.writer.lname}`}
                  data={comment.createdAt}
                  comment={comment.comment}
                  avatar={comment.writer.avatar}
                />
              ))}
              <Paginate {...{ totalPage, page, setPage }} />
            </>
          ) : (
            <Loading />
          )}
        </div>
      </div>

      <Footer />
    </>
  )
}
export default CommentsLawer
